import React, { useState } from "react";
import { Link } from "react-router-dom";
import Header from "../components/Header";
import { Button } from "../components/ui/button";
import { Textarea } from "../components/ui/textarea";
import { Input } from "../components/ui/input";
import { toast } from "sonner";

export default function DataDeletion() {
  const [email, setEmail] = useState("");
  const [reason, setReason] = useState("");

  const openMailClient = () => {
    if (!email) { toast.error("Please enter your account email"); return; }
    const subject = encodeURIComponent("Delete my BrimiAI ScienceLab account");
    const body = encodeURIComponent(
      `Hi Brimi team,\n\nPlease delete my BrimiAI · ScienceLab account and all associated data.\n\nAccount email: ${email}\nReason (optional): ${reason || "—"}\n\nThanks.`
    );
    window.location.href = `mailto:brajeshc56@gmail.com?subject=${subject}&body=${body}`;
    toast.success("Opening your email app…");
  };

  return (
    <div className="min-h-screen">
      <Header />
      <div className="max-w-2xl mx-auto px-4 sm:px-8 py-10 text-white">
        <div className="brut-card bg-white text-[#0F1120] p-6 sm:p-10 rounded-none">
          <div className="text-xs font-bold tracking-[0.3em] uppercase text-neutral-500">Account</div>
          <h1 className="text-3xl sm:text-4xl font-black mt-1 mb-2">Delete My Data</h1>
          <p className="text-neutral-700 mb-6">
            You can request permanent deletion of your BrimiAI · ScienceLab account and
            all associated data (profile, chat history, quiz attempts, feedback,
            subscription record). Deletions are processed within 7 business days.
          </p>

          <div className="space-y-3">
            <div>
              <label className="text-xs font-bold uppercase tracking-widest">Account email</label>
              <Input
                data-testid="deletion-email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="you@example.com"
                className="brut-input rounded-none mt-1"
              />
            </div>
            <div>
              <label className="text-xs font-bold uppercase tracking-widest">Reason (optional)</label>
              <Textarea
                data-testid="deletion-reason"
                value={reason}
                onChange={(e) => setReason(e.target.value)}
                maxLength={500}
                placeholder="Anything you'd like to tell us…"
                className="brut-input rounded-none mt-1 min-h-[100px]"
              />
            </div>
            <Button
              data-testid="deletion-submit"
              onClick={openMailClient}
              className="brut-btn rounded-none w-full bg-[#1A1A1A] text-white hover:bg-[#1A1A1A]">
              Send Deletion Request
            </Button>
          </div>

          <div className="mt-8 text-sm text-neutral-600">
            <div className="font-bold text-[#0F1120]">What will be deleted?</div>
            <ul className="list-disc pl-6 mt-2 space-y-1">
              <li>Your profile (name, email, hashed password, class).</li>
              <li>Chat sessions and prompts.</li>
              <li>Quiz history, mock test attempts, and feedback comments.</li>
              <li>Subscription record (payment invoices held by Razorpay follow their retention policy).</li>
            </ul>
          </div>

          <div className="mt-10 flex gap-3">
            <Link to="/" className="brut-btn rounded-none bg-white text-[#0F1120] hover:bg-white" data-testid="deletion-back-home">Back to Home</Link>
            <Link to="/privacy" className="brut-btn rounded-none bg-[#E9E6FA] text-[#0F1120] hover:bg-[#E9E6FA]" data-testid="deletion-to-privacy">Privacy Policy</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
